import { Injectable } from '@angular/core';
// import { ResponseContentType } from '@angular/http';
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ICommandParameters } from './iCommandParameters';
import { EndPointEnum } from './endPointEnum.enum';
import { IRequestCommand } from './iRequestCommand';
import { ICommandResponse } from './iCommandResponse';
import { CommandRequestType } from './commandRequestType';
import { IdentityService } from '../identity.service';
import { Observable, catchError, from, map } from 'rxjs';
import { RequestContentTypeEnum } from './requestContentTypeEnum.enum';

// import { IdentityService } from 'app/services/authentication/identity.service';e
// import { GetTravelsCommand } from '../travel/command/getTravels.command';
// import { NgProgress } from 'ngx-progressbar';

@Injectable()
export class ConnectionServices {
  private apiUrl: string;
  constructor(
    private _http: HttpClient,
    private _configService: ConfigService,
    private _identityService: IdentityService,
    // private _spinnerService: SpinnerService,
    // private _ngProgressService: NgProgress
  ) {
    this.apiUrl = this._configService.config.apiUrl;
  }

  // tslint:disable-next-line:max-line-length
  public Request<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<
      TReturnData,
      HttpErrorContainer,
      TCommandParameters
    >, isMessage?: boolean, isApiPublic?: boolean
  ) {
    // this._ngProgressService.start();

    // this._ngProgressService.show('mySpinner');

    command._needAuthenticate = true;

    if (command.endPointType === EndPointEnum.MagiisApi) {
      this.apiUrl = this._configService.config.apiUrl;
    }
    if (command.endPointType === EndPointEnum.TraslatorApi) {
      this.apiUrl = this._configService.config.traslatorApiUrl;
    }
    if (isMessage) {
      this.apiUrl = this._configService.config.notificationsApiUrl
    } else {
      this.apiUrl = this._configService.config.apiUrl;

      if (isApiPublic) {
        command._needAuthenticate = false;
        this.apiUrl = this._configService.config.apiPublicUrl;
      }
    }



    if (command.commandType === CommandRequestType.POST) {
      return this.mapWithException(
        this.post<TReturnData, HttpErrorContainer, TCommandParameters>(command)
      );
    } else if (command.commandType === CommandRequestType.GET) {
      return this.mapWithException(
        this.get<TReturnData, HttpErrorContainer, TCommandParameters>(command)
      );
    } else if (command.commandType === CommandRequestType.PUT) {
      return this.mapWithException(
        this.put<TReturnData, HttpErrorContainer, TCommandParameters>(command)
      );
    } else if (command.commandType === CommandRequestType.DELETE) {
      return this.mapWithException(
        this.delete<TReturnData, HttpErrorContainer, TCommandParameters>(command)
      );
    } else if (command.commandType === CommandRequestType.PATCH) {
      return this.mapWithException(
        this.patch<TReturnData, HttpErrorContainer, TCommandParameters>(command)
      );
    }

    return null;
  }

  // tslint:disable-next-line:max-line-length
  private mapWithException<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(response: Observable<TReturnData>) {
    const source = from(response);
    // tslint:disable-next-line:no-shadowed-variable
    return source.pipe(
      map(responses => {
        return responses;
      }),
      catchError(ex => {
        throw ex;
      })
    );
      // .catch(ex => {
      //   this._spinnerService.hide('mySpinner');
      //   // if (ex.error != null && ex.error !== undefined) {
      //   //   if (ex.error.errors !== undefined) {
      //   //     this._globalExceptionsService.notificationExceptions(
      //   //       ex.error.errors
      //   //     );
      //   //   } else {
      //   //     this._globalExceptionsService.notificationExceptions(ex.error);
      //   //   }
      //   // } else {
      //   //   if (ex.message !== null) {
      //   //     this._globalExceptionsService.notificationExceptions(ex.message);
      //   //   } else {
      //   //     this._globalExceptionsService.notificationExceptions(ex);
      //   //   }
      //   // }
      //   return Observable.throw(ex);
      // });
  }
  private newMethod<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >() {
    return this;
  }

  private extractData(res: any) {
    const data = res;
    return data;
  }
  // tslint:disable-next-line:max-line-length
  private get<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<TReturnData, TError, TCommandParameters>
  ): Observable<TReturnData> {
    const options = this.setOptions(command);
    return this._http.get<TReturnData>(
      this.apiUrl + command.commandUrl,
      options
    );
  }
  private post<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<TReturnData, TError, TCommandParameters>
  ): Observable<TReturnData> {
    const options = this.setOptions(command);
    if (command.responseContentType === RequestContentTypeEnum.ArrayBuffer) {
      // This method uses for download file
      (<any>options).responseType = 'blob';
      const arrayBufferResponse = <any>(
        this._http.post(
          this.apiUrl + command.commandUrl,
          command.commandBody,
          options
        )
      );
      return arrayBufferResponse;
    } else {
      return this._http.post<TReturnData>(
        this.apiUrl + command.commandUrl,
        command.commandBody,
        options
      );
    }
  }
  private put<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<TReturnData, TError, TCommandParameters>
  ): Observable<TReturnData> {
    const options = this.setOptions(command);

    return this._http.put<TReturnData>(
      this.apiUrl + command.commandUrl,
      command.commandBody,
      options
    );
  }
  private delete<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<TReturnData, TError, TCommandParameters>
  ): Observable<TReturnData> {
    const options = this.setOptions(command);

    return this._http.delete<TReturnData>(
      this.apiUrl + command.commandUrl,
      options
    );
  }

  private patch<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(
    command: IRequestCommand<TReturnData, TError, TCommandParameters>
  ): Observable<TReturnData> {
    const options = this.setOptions(command);

    return this._http.patch<TReturnData>(
      this.apiUrl + command.commandUrl,
      options
    );
  }

  // Set options in header and other parametter to require for the request
  // tslint:disable-next-line:max-line-length
  private setOptions<
    TReturnData extends ICommandResponse,
    TError,
    TCommandParameters extends ICommandParameters
  >(command: IRequestCommand<TReturnData, TError, TCommandParameters>) {
    let headersAppend = new HttpHeaders();
    if (command.canAddCustomHeaders && command.replaceDefaultHeader) {
      // need to replace all header for the custom
      for (const item of command.customHeader) {
        headersAppend = headersAppend.append(item.name, item.value);
      }
      // tslint:disable-next-line:no-shadowed-variable
      const options = {
        headers: headersAppend
      };
      return options;
    } else {
      if (command.canAddCustomHeaders && !command.replaceDefaultHeader) {
        // add custom header to the default header
        for (const item of command.customHeader) {
          headersAppend = headersAppend.append(item.name, item.value);
        }
      }
    }
    // TODO: Need to use the parameter
    // if (command.responseContentType == ResponseContentType.Blob)
    //     headersAppend = headersAppend.append('responseType', 'blob');
    // else
    //     headersAppend = headersAppend.append('Content-Type', command.requestContentTypeƒ);

    if (command.needAuthenticate) {
      headersAppend = headersAppend.append(
        'Authorization',
        `Bearer ${this._identityService.sessionToken}`
      );
    }

    const options = {
      headers: headersAppend
    };

    return options;
  }
}

export class EndPointUrl {
  static login = '/login';
}

// tslint:disable-next-line:no-empty-interface
export interface HttpErrorContainer {}
